import $ from 'jquery';
import Slideshow from 'picnic/Slideshow';


function __createBreakpoint(upToWidth, amount) {
	return {
		breakpoint: upToWidth,
		settings: {
			slidesToShow: amount,
			slidesToScroll: amount
		}
	};
}


var
	SELECTOR_SLIDESHOW = '.slideshow:first',
	CLASS_INFINITE = 'is-infinite',
	CLASS_VERTICAL = 'is-vertical',
	CLASS_FIXED = 'is-fixed',
	CLASS_VISIBLE = 'is-visible',
	DATA_AMOUNT = 'amount',
	BREAKPOINTS_FOR_1_ITEM = [],
	BREAKPOINTS_FOR_2_ITEMS = [
		__createBreakpoint(600, 2)
	],
	BREAKPOINTS_FOR_3_ITEMS = [
		__createBreakpoint(450, 2),
		__createBreakpoint(600, 3)
	],
	BREAKPOINTS_FOR_4_ITEMS = [
		__createBreakpoint(450, 2),
		__createBreakpoint(600, 3),
		__createBreakpoint(750, 4)
	],
	BREAKPOINTS_FOR_5_ITEMS = [
		__createBreakpoint(450, 2),
		__createBreakpoint(600, 3),
		__createBreakpoint(750, 4),
		__createBreakpoint(900, 5)
	],
	BREAKPOINTS =  [
		BREAKPOINTS_FOR_1_ITEM,
		BREAKPOINTS_FOR_2_ITEMS,
		BREAKPOINTS_FOR_3_ITEMS,
		BREAKPOINTS_FOR_4_ITEMS,
		BREAKPOINTS_FOR_5_ITEMS
	]
;


class View extends Slideshow {

	constructor(options) {
		var
			element = $(options.el || options.$el),
			amount = element.data(DATA_AMOUNT) || 1,
			settings = {
				responsive: BREAKPOINTS[amount - 1],
				dots: true,
				arrows: true,
				infinite: element.hasClass(CLASS_INFINITE),
				vertical: element.hasClass(CLASS_VERTICAL),
				adaptiveHeight: !element.hasClass(CLASS_FIXED),
				slide: ':not(template)'  // Ignore Django generated template tags
			}
		;

		super($.extend(true, {
			selector: SELECTOR_SLIDESHOW,
			settings: settings
		}, options));
	}

	render() {
		super.render();

		this._visiblePagination(this.$el.find('.pagination .slick-active'));
		this.$el.find(SELECTOR_SLIDESHOW)
			.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
				this.context.dispatch('slideshow:change', {slick, currentSlide, nextSlide});
				const $el = this.$el.find('.pagination').find('.slick-active');
				this._visiblePagination((currentSlide < nextSlide) ? $el.next() : $el.prev());
			})
		;

		return this;
	}

	// Limit pagination
	_visiblePagination($el) {
		const max = 3;
		$el.siblings().removeClass(CLASS_VISIBLE);
		$el.nextAll().slice(0, max * 2 - $el.prevAll().slice(0, max).length).addClass(CLASS_VISIBLE);
		$el.prevAll().slice(0, max * 2 - $el.nextAll().slice(0, max).length).addClass(CLASS_VISIBLE);
	}


}

export default View;
